import gql from 'graphql-tag';

export const UPDATE_ACCOUNT = gql`
  mutation UpdateAccountNickname($id: Int!, $input: UpdateAccountInput!) {
    updateAccount(id: $id, input: $input) {
      id
      name
    }
  }
`;

export const updateAccountNicknameMock = {
  updateAccount: {
    id: 1,
    name: 'tester',
  },
};
